(() => {
  const bannerSelector = '.image-responsive-wrapper, .image-banner, .slideshow, .video-banner, .split-screen-slideshow, .gt-hero, .n26-hero, .rtp-hero, .nd-bf__hero, .drx-hero';
  const textSelector = '.slideshow-slide__text, .image-banner__wrapper, .video-banner__wrapper, .raices-hero__content, .split-screen-slideshow__text-slide, .gt-hero-content, .n26-hero__grid, .rtp-hero-content, .drx-hero__in';
  let observer;
  let frame;
  let spacedElements = [];
  let geometry;
  let needsLayout = false;

  const setStyle = (element, property, value) => {
    if (element.style.getPropertyValue(property) !== value) {
      element.style.setProperty(property, value);
    }
  };
  const toggleClass = (element, name, active) => {
    if (element.classList.contains(name) !== active) {
      element.classList.toggle(name, active);
    }
  };

  const clearSpacing = () => {
    spacedElements.forEach(element => {
      element.classList.remove('header-content-clearance');
      element.style.removeProperty('--header-content-clearance');
      element.style.removeProperty('--header-original-padding');
    });
    spacedElements = [];
    geometry = null;
  };

  const update = () => {
    const header = document.querySelector('.shopify-section-header');
    const main = document.querySelector('#MainContent');
    if (!header || !main) return;
    // Floating widgets and empty sections do not count as opening content.
    const first = [...main.children].find(element => element.getBoundingClientRect().height > 1);
    const banner = first?.matches(bannerSelector) ? first : first?.querySelector(bannerSelector);
    const overlay = banner && banner.getBoundingClientRect().height > 1
      && Math.abs(banner.getBoundingClientRect().top - first.getBoundingClientRect().top) < 2;

    if (!overlay) {
      clearSpacing();
      header.classList.remove('header-overlay');
      header.style.removeProperty('--overlay-header-height');
      header.style.removeProperty('--overlay-header-offset');
      return;
    }

    const targets = [...banner.querySelectorAll(textSelector)].filter(element => !element.parentElement.closest(textSelector));
    const headerHeight = header.offsetHeight;
    const bannerRect = banner.getBoundingClientRect();
    const firstTop = first.getBoundingClientRect().top + window.scrollY;
    const sameTargets = targets.length === spacedElements.length
      && targets.every((element, index) => element === spacedElements[index]);
    if (sameTargets && geometry && geometry.headerHeight === headerHeight
      && geometry.firstTop === firstTop && geometry.bannerHeight === bannerRect.height
      && geometry.width === window.innerWidth) return;
    if (targets.length !== spacedElements.length || targets.some((element, index) => element !== spacedElements[index])) {
      clearSpacing();
      targets.forEach(element => {
        setStyle(element, '--header-original-padding', getComputedStyle(element).paddingTop);
        element.classList.add('header-content-clearance');
      });
      spacedElements = targets;
    }
    spacedElements.forEach(element => setStyle(element, '--header-content-clearance', `${headerHeight + 24}px`));
    setStyle(header, '--overlay-header-height', `${headerHeight}px`);
    toggleClass(header, 'header-overlay', true);
    // Measure in normal flow even when the sticky header is pinned to the viewport.
    const previousPosition = header.style.position;
    header.style.position = 'relative';
    const previousOffset = parseFloat(header.style.getPropertyValue('--overlay-header-offset')) || 0;
    const offset = banner.getBoundingClientRect().top - header.getBoundingClientRect().top + previousOffset;
    setStyle(header, '--overlay-header-offset', `${offset}px`);
    header.style.position = previousPosition;
    geometry = {
      headerHeight,
      firstTop: first.getBoundingClientRect().top + window.scrollY,
      bannerHeight: banner.getBoundingClientRect().height,
      width: window.innerWidth,
    };
  };

  const updateScroll = () => {
    const header = document.querySelector('.shopify-section-header');
    if (header) toggleClass(header, 'header-scrolled', window.scrollY > 8);
    if (!header || !document.querySelector('.n26-hero, .drx-hero')) return;
    const rect = header.getBoundingClientRect();
    const y = Math.max(0, Math.min(window.innerHeight - 1, rect.top + rect.height / 2));
    let surface = document.elementsFromPoint(window.innerWidth / 2, y)
      .find(element => element.closest('#MainContent'));
    while (surface) {
      const channels = getComputedStyle(surface).backgroundColor.match(/[\d.]+/g)?.map(Number);
      if (channels && (channels.length === 3 || channels[3] > 0.5)) {
        const brightness = channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
        toggleClass(header, 'header-over-dark', brightness < 140);
        toggleClass(header, 'header-over-light', brightness >= 140);
        return;
      }
      surface = surface.parentElement;
    }
  };

  const queueUpdate = (layout) => {
    needsLayout = needsLayout || layout;
    if (frame !== undefined) return;
    frame = requestAnimationFrame(() => {
      frame = undefined;
      if (needsLayout) {
        needsLayout = false;
        update();
      }
      updateScroll();
    });
  };
  const schedule = () => queueUpdate(true);
  const scheduleScroll = () => queueUpdate(false);
  const initialize = () => {
    observer?.disconnect();
    clearSpacing();
    observer = new ResizeObserver(schedule);
    document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-header, #MainContent, #MainContent > *').forEach(element => observer.observe(element));
    schedule();
    updateScroll();
  };
  window.addEventListener('resize', initialize);
  window.addEventListener('load', schedule);
  window.addEventListener('scroll', scheduleScroll, { passive: true });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', initialize);
  document.addEventListener('shopify:section:reorder', initialize);
  initialize();
})();
